<template>
  <div style="background-color: white !important; height:100vh;">
    <div style="padding: 200px 20px 20px 20px; margin: 0 auto; max-width: 400px">
      <div class="row">
        <div class="col-md-12">
          <div v-if="verificacion.verificando || verificacion.status == 'warning'" class="ibox-content" style="border-color: white">
            <div>
                <img width="300" style="padding: 20px;display: block;margin-left: auto;margin-right: auto;" src="../assets/logo.png">
                <h2 style="text-align: center">
                  {{ verificacion.msg }}
                </h2>
                <b-skeleton v-if="verificacion.verificando" type="input"></b-skeleton>
                <b-button style="margin-top: 20px; width:100%" v-if="!verificacion.verificando && verificacion.status != 'success'" variant="primary" v-on:click="volver()">Volver</b-button>
            </div>
          </div>
          <div v-else class="ibox-content" style="border-color: white">
            <div>
                <img width="300" style="padding: 20px;display: block;margin-left: auto;margin-right: auto;" src="../assets/logo.png">
                <h1 style="text-align: center">Crear nueva contraseña</h1>
            </div>
            <div class="form-group">
              <label>Usuario</label>
              <input v-model="correo" class="form-control" readonly placeholder="Correo" required="true">
            </div>
            <div class="form-group">
              <label>Nueva contraseña</label>
              <input type="password" v-model="pass_1" class="form-control" placeholder="Contraseña" required="true" >
            </div>
            <div class="form-group">
              <label>Repita contraseña</label>
              <input type="password" v-model="pass_2" class="form-control" placeholder="Contraseña" required="true" >
            </div>
            <b-button v-if="!loading" variant="primary" v-on:click="cambiarPass()" style="margin-top: 20px; width:100%">Cambiar contraseña</b-button>
            <b-button v-else variant="primary" style="margin-top: 20px; width:100%"><Loading :size="'1'" :text="'Cambiando contraseña'"/></b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {userService} from "@/services";
import {utils} from "@/helpers";

var sha1 = require('js-sha1');

export default {
  data() {
    return {
      hash:'',
      correo:'',
      pass_1:'',
      pass_2:'',
      loading:false,
      verificacion:{
        verificando:true,
        status:'warning',
        msg:'Verificando enlance de cambio de contraseña'
      }
    }
  },
  mounted(){
    this.hash = utils.jd64(this.$route.query.p).hash;
    this.correo = utils.jd64(this.$route.query.p).correo;
    this.verificarCorreoUniqueId();
  },
  methods : {
    volver(){
      this.$router.push("/login");
    },
    verificarCorreoUniqueId(){
      this.verificacion.verificando = true;

      userService.verificarCorreoUniqueId({
        correo:this.correo,
        hash: this.hash
      }).then(respuesta => {
        this.verificacion.verificando = false;
        this.verificacion.status = respuesta.status;
        this.verificacion.msg = respuesta.msg;
      });
    },
    cambiarPass(){
      if(this.pass_1 == "" || this.pass_2 == ""){
        utils.alerta({status:'warning',msg:'Debe ingresar ambas contraseñas'});
        return;
      }

      if(this.pass_1 != this.pass_2){
        utils.alerta({status:'warning',msg:'Las contraseñas ingresadas no son iguales'});
        return;
      }

      console.log(this.pass_1);
      console.log(this.pass_2);

      if(this.pass_1.length < 8){
        utils.alerta({status:'warning',msg:'La contraseña debe tener 8 caracteres o más'});
        return;
      }

      this.loading = true;

      userService.putNuevaPass({
        correo: this.correo, 
        pass: sha1(this.pass_1),
        hash: this.hash
      }).then(respuesta => {
        utils.alerta(respuesta);

        if(respuesta.status == 'success'){
          this.$router.push("/login");
        }
        
        this.loading = false;
      });
    },
  }
}
</script>

<style scoped>
</style>
